import { ProfilePageContainer } from "@/components/container/profile-page-container";
import { useIonRouter } from "@ionic/react";
import MealCreatingProgress from "../../components/meal-creating-progress";
import { useCheckAllCandidateCreation } from "../../hooks/use-check-all-candidate-creation";

export default function GoToCandidatesCreating() {
  const navigation = useIonRouter();
  useCheckAllCandidateCreation({
    onCompleted: () => {
      navigation.push("/profiling/go-to/add-plan", "forward", "replace");
    },
  });
  return (
    <ProfilePageContainer
      showToolbar={false}
      className="h-full flex flex-col items-center justify-center"
    >
      <MealCreatingProgress />
    </ProfilePageContainer>
  );
}
